module.exports = __webpack_public_path__ + "static/sidebar2-2dcaadf2730b8635edede09d5e105208.png";